import Error from '../../pages/_error.page'

export interface WithErrorProps {
  error?: boolean
  statusCode?: number
}

export const withErrorComponent = <P extends object>(
  Component: React.ElementType
): React.FC<React.PropsWithChildren<P & WithErrorProps>> =>
  function withErrorComponent({ error, statusCode, ...props }: WithErrorProps) {
    return error ? (
      <Error statusCode={statusCode || 500} />
    ) : (
      <Component {...(props as P)} />
    )
  }
